module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "filter-button",
    class: {
      'filter-button_active': _vm.isActive
    },
    on: {
      "click": function($event) {
        return _vm.$emit('selectedType')
      }
    }
  }, [(_vm.$slots.icon) ? _c('div', {
    staticClass: "filter-button__icon"
  }, [_vm._t("icon")], 2) : _vm._e(), (_vm.$slots.icon) ? _c('div', {
    staticClass: "filter-button__text"
  }, [_vm._t("default")], 2) : [_vm._t("default")]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b0afeb2","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterbutton/FilterButton.vue
// module id = 8c1ba6536eef5d26bf76
// module chunks = 7